import baseApi from "./baseApi";
//import moment from "moment";

export default {
    async getDepartmentCodes(plantID) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/cropwork/DepartmentCodes?plantID=${plantID}`);
        return result.data;
    },
    async getDivisions(plantID) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/cropwork/Divisions?plantID=${plantID}`);
        return result.data;
    },
    async getProductCategories(plantID) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/cropwork/ProductCategories?plantID=${plantID}`);
        return result.data;
    },
    async saveDepatmentCode(data) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post(`/cropwork/DepartmentCodes`, data)
        return result.data;
    },
    async getActivities(plantID) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/cropwork/Activities?plantID=${plantID}`);
        return result.data;
    },
    async saveActivity(data) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post(`/cropwork/Activities`, data)
        return result.data;
    }
    // async getPlantProfileTemplates(plantID){
    //     let request = await baseApi.createHttpRequest();
    //     let result = await request.get(`/forecasting/PlantProfileTemplateData?plantID=${plantID}`);
    //     return result.data;
    // },
    // async postUpdateForecastProfile(unsentForecastProfile){
    //     let request = await baseApi.createHttpRequest();
    //     let result = await request.post("/forecasting/updateForecastProfileData", unsentForecastProfile);

    //     return result.data;
    // },
}